import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from 'src/app/app.constants';
import { ILoadingTypeMySuffix } from 'src/app/shared/model/loading-type-my-suffix.model';
import { createRequestOption } from 'src/app/shared/util/request-util';


type EntityResponseType = HttpResponse<ILoadingTypeMySuffix>;
type EntityArrayResponseType = HttpResponse<ILoadingTypeMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class LoadingTypeMySuffixService {
    private baseurl = SERVER_API_URL + 'api/';
    private resourceUrl = SERVER_API_URL + 'api/loading-types';
    private resourceUrlAll = SERVER_API_URL + 'api/loading-types/all';
    private resourceRuleUrl = SERVER_API_URL + 'api/loading-types/rule/';

    constructor(private http: HttpClient) {}

    create(loadingType: ILoadingTypeMySuffix): Observable<EntityResponseType> {
        return this.http.post<ILoadingTypeMySuffix>(this.resourceUrl, loadingType, { observe: 'response' });
    }

    update(loadingType: ILoadingTypeMySuffix): Observable<EntityResponseType> {
      
        return this.http.put<ILoadingTypeMySuffix>(this.resourceUrl, loadingType, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<ILoadingTypeMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<ILoadingTypeMySuffix[]>(this.resourceUrl, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    queryByRuleId(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        if (!req) {
            req = 0;
        }
        return this.http.get<ILoadingTypeMySuffix[]>(this.resourceRuleUrl + req, { params: options, observe: 'response' });
    }

    queryAll(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<ILoadingTypeMySuffix[]>(this.resourceUrl + '/all', { params: options, observe: 'response' });
    }
    loadingType(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<ILoadingTypeMySuffix[]>(SERVER_API_URL + 'api/policy-loading-types/all', {
            params: options,
            observe: 'response'
        });
    }
    findByIdAndFromEffectiveDate(id: number, fromEffectiveDate: string): Observable<EntityResponseType> {
        return this.http.get<ILoadingTypeMySuffix>(`${this.resourceUrl}/${id}/${fromEffectiveDate}`, { observe: 'response' });
    }
    get(url:string){
        return this.http.get<any>(this.baseurl+url, { observe: 'response' }).map((res) => res);
    }
}
